import { boot } from 'quasar/wrappers'
import numeral from 'numeral'
import { DateTime } from 'luxon'

type NumeralFunc = (input: number | string) => numeral.Numeral
type DateTimeInput = string | DateTime
interface DateTimeFormat {
  toFormat(input: DateTimeInput, format: string): string
  shortFormat(input: DateTimeInput): string
  fullFormat(input: DateTimeInput): string
}
declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $numeral: NumeralFunc
    $dt: DateTimeFormat
  }
}

const getDate = (input: DateTimeInput): DateTime => {
  if (input instanceof DateTime) {
    return input
  }
  return DateTime.fromISO(input)
}

export default boot(({ app }) => {
  // Numeral Setup
  app.config.globalProperties.$numeral = (input: number | string) =>
    numeral(input)

  // Date time format
  app.config.globalProperties.$dt = {
    toFormat: (input: DateTimeInput, format: string): string => {
      return getDate(input).toFormat(format)
    },
    shortFormat: (input: DateTimeInput): string => {
      return getDate(input).toLocaleString(DateTime.DATETIME_SHORT)
    },
    fullFormat: (input: DateTimeInput): string => {
      return getDate(input).toLocaleString(DateTime.DATETIME_MED)
    },
  }
})

export function telephoneFormatter(phoneNumber: string) {
  // Clean phone number
  if (phoneNumber) {
    if (phoneNumber.includes('-')) {
      return phoneNumber.replace(/-/g, '');
    }
  }
  return phoneNumber
}